import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthProvider';
import { AppShell } from '@/shared/layout/AppShell';
import { Spinner } from '@/shared/ui';

type ProtectedRouteProps = {
  acoes?: number[];
  semShell?: boolean;
};

export function ProtectedRoute({ acoes, semShell = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, authGate, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Spinner fullViewport message="Carregando…" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (authGate === 'primeiro-acesso') {
    return <Navigate to="/primeiro-acesso" replace state={{ from: location }} />;
  }

  if (authGate === 'escolher-escola') {
    return <Navigate to="/escolher-escola" replace state={{ from: location }} />;
  }

  if (acoes?.length) {
    const tem = acoes.some((a) => user?.acoes.includes(a));
    if (!tem) {
      return <Navigate to="/403" replace />;
    }
  }

  if (semShell) {
    return <Outlet />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
